import { Text, theme, Avatar } from 'components';
import React from 'react';
import styled from 'styled-components';

type Label = {
  firstName: string;
  lastName?: string;
  name?: string;
  logo?: string;
  orgName?: string;
};

const AgentLabel = (label: Label) => {
  const { name, firstName, lastName, logo, orgName } = label;

  const props: any = {};
  props.user = {
    firstName,
    lastName,
    avatarFilestackId: logo,
  };
  if (logo) {
    props.backgroundColor = 'background';
  }
  return (
    <>
      <FlexContainer>
        <Avatar {...props} />
        <NameContainer>
          <Text style={{ marginLeft: '5px' }} ellipsis block>
            {name}
          </Text>
        </NameContainer>
      </FlexContainer>
      <AdditionalInfoContainer>
        <StyledType>{orgName}</StyledType>
      </AdditionalInfoContainer>
    </>
  );
};

const StyledType = styled(Text)`
  margin: 0px 5px;
  color: ${theme.gray6};
  font-weight: 500;
`;

const FlexContainer = styled.div`
  display: flex;
  align-items: center;
`;

const NameContainer = styled.div`
  display: flex;
  align-items: center;
  width: 85%;
`;

const AdditionalInfoContainer = styled.div`
  padding-left: 0px;
`;

export default AgentLabel;
